import React, {Component} from 'react';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import Table from '../components/pivottable';

const SUBMISSIONS = 'https://5dum6c4ytb.execute-api.us-east-1.amazonaws.com/dev/submissions';
const DEFAULT = {
    rows: ['lab'],
    cols: ['assay', 'registered'],
    data: []
};
class AllSubmissions extends Component {
    state = {
        submissions: [],
        download: null
    }

    componentDidMount() {
        axios
            .get(SUBMISSIONS)
            .then(res => this.setState({
                submissions: parseSubmissions(res.data.body)
            }))
            .catch(err => console.log(err));
    }

    render() {
        return (
            <div className="test">
                <Table data={this.state.submissions} DEFAULT={DEFAULT}/>
            </div>
        );
    }
}

export default AllSubmissions;

function parseSubmissions(submissions) {
    const production = submissions.filter(sub => sub.data_phase === 'pilot' && sub.assay !== 'RRBS-seq');
    const submissionsSE = production.filter(sub => sub.read_type === 'Single-end' || sub.read_type === 'single-end');
    const submissionsPE = production.filter(sub => sub.read_type === 'Paired-end' || sub.read_type === 'paired-end');

    const filesPE = getFilesPE(submissionsPE);
    const filesSE = getFilesSE(submissionsSE);
    const allFiles = filesPE.concat(filesSE);
    console.log(allFiles.sort(compare));
    return allFiles.sort(compare);
}

function getFilesPE(submissions) {
    const filteredFiles = submissions.map(sub => {
        const {lab, assay, registered, _id} = sub;
        return sub
            .validated_files
            .filter(file => {
                if (/R2/.test(file.identifier)) {
                    return null
                } else {
                    return file
                }
            })
            .map(file => ({
                uuid: file.uuid,
                filename: file.filename,
                lab: lab,
                assay: assay,
                registered: moment(registered).format('MMM YYYY'),
                submission: _id
            }))
    });

    const filesArray = _.flattenDeep(filteredFiles);

    return filesArray;
}

function getFilesSE(submissions) {

    let filesArray = submissions.map(submission => {
        return submission.validated_files
            .map(file => ({
                uuid: file.uuid,
                filename: file.filename,
                lab: submission.lab,
                assay: submission.assay,
                registered: moment(submission.registered).format('MMM YYYY'),
                submission: submission._id
            }))
    });

    let files = _.flattenDeep(filesArray);

    return files;
}

function compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const registeredA = a.registered.toUpperCase();
    const registeredB = b.registered.toUpperCase();

    let comparison = 0;
    if (new Date(registeredA) > new Date(registeredB)) {
        comparison = 1;
    } else if (new Date(registeredA) < new Date(registeredB)) {
        comparison = -1;
    }
    return comparison;
}



// WEBPACK FOOTER //
// ./src/components/AllSubmissions.js